import React from 'react';
import { DiscordUser } from '../Types';

interface UserPfpProps {
    user?:{id:string, avatar?:string | null | undefined, username?:string};
    size?: number;
}

const UserPfp: React.FC<UserPfpProps> = ({ user, size = 32 }) => (
    <img
        src={user && user.avatar ? `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.webp?size=${size}` : `https://discord.com/assets/2ccd8ae8b2379360.png?size=${size}&format=webp&quality=lossless`}
        width={size}
        height={size}
        alt={user && user.username ? `${user.username}'s avatar` : 'User avatar'}
        className="pfp"
    />
);

export default UserPfp;